import createReducer from "../../createReducer";
import { mailchimpListsHandlers } from "../handlers";
import { IMailchimpListsState } from "../types";

export const getMailchimpListsReducer: IMailchimpListsState = {
    isLoading: false,
    error: null,
    mailchimpData: {},
};
export default createReducer(getMailchimpListsReducer, mailchimpListsHandlers);
